<template>
  <div>
    <template v-if="getUser.super_admin">
      <DashboardSuperAdmin/>
    </template>
    <template v-else>
      <DashboardAdmin/>
    </template>
  </div>
</template>

<script>
import TitlePage from "../components/utils/TitlePage";
import DashboardAdmin from "@/components/admin/DashboardAdmin";
import DashboardSuperAdmin from "@/components/admin/DashboardSuperAdmin";
import {mapGetters} from "vuex";

export default {
  name: 'Dashboard',
  components: {DashboardAdmin,DashboardSuperAdmin,TitlePage},
  data() {
    return {

    };
  },

  computed: {
    ...mapGetters({
      'getUser': 'user/getUser',
    }),
  },
  methods: {

  },
  mounted() {

  },

}
</script>